export function GET_AUTH_TELE( token: string) {
  return {
    url: process.env.REACT_APP_API_URL_TELEHEALTH  + `auth/${token}`,
    options: {
      method: "GET"
    },
  };
}
